<template>
  <!-- <div class="pageBuild">
    <h1>Transfer</h1>
    <p>This section is not yet available</p>
  </div> -->
  <div class="transfer-container">
    <div class="title">{{ $t("transfer.title") }}</div>
    <div class="body">{{ $t("transfer.subTitle") }}</div>

    <div class="options">
      <CustomSelector v-model="platform" :placeholder="this.$t('transfer.platform')" :options="platforms">
      </CustomSelector>
      <div v-if="platform === 'mt4' || platform === ''" class="">
        <CustomSelector v-model="source" :placeholder="this.$t('transfer.sourceAcount')" :options="sources"
          @click="loadTarget()"></CustomSelector>
      </div>
      <div v-if="platform === 'mt5'" class="">
        <CustomSelector v-model="source" :placeholder="this.$t('transfer.sourceAcount')" :options="sources"
          @click="loadTarget()"></CustomSelector>
      </div>
      <div v-if="platform === 'mt4' || platform === ''" class="">
        <CustomSelector v-model="target" :placeholder="this.$t('transfer.targetAccount')" :options="targets">
        </CustomSelector>
      </div>

      <div v-if="platform === 'mt5'" class="">
        <CustomSelector v-model="target" :placeholder="this.$t('transfer.targetAccount')" :options="targets">
        </CustomSelector>
      </div>

      <input class="cabinet-input" type="number" :placeholder="this.$t('transfer.sendingAmount')" v-model="amount" />

      <label class="input-checkbox" v-if="region === 'mena'">
        {{ $t("transfer.condition") }}
        <input type="checkbox" v-model="checkbox" />
        <span class="checkmark"></span>
      </label>

      <label class="input-checkbox" v-else>
        {{ $t("transfer.condition2") }}
        <input type="checkbox" v-model="checkbox" />
        <span class="checkmark"></span>
      </label>
    </div>

    <button class="red-button" @click="sendTransfer" :disabled="disabledBtn">
      {{ $t("transfer.start") }}
    </button>
  </div>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";
import {
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "@vue/runtime-core";
import store from "@/store";
import { Logger } from "aws-amplify";
import axios from "axios";
import { computed } from "@vue/reactivity";
import Preloader from "@/components/Preloader";
import { i18n } from "@/plugins/i18n";
import { accountslv4, accountslv5 } from "../../plugins/authUtils";
/* import { useRoute } from "vue-router"; */
const logger = new Logger("main");

export default {
  name: "Transfer",
  components: { CustomSelector, Preloader },
  setup() {
    let status_user = ref("");
    let source = ref(null);
    let sources = ref([]);
    let target = ref(null);
    let targets = ref([]);
    let amount = ref(null);
    let supportLanguage = ref(null);
    let checkbox = ref(false);
    let busy = ref(false);
    let accounts = ref([]);
    let disabledBtn = ref(false);
    let showM = ref(false);
    let platform = ref("");
    let accountsLive = ref([]);
    let accountsNumber = ref(null);

    let platforms = ref([
      {
        value: "mt4",
        text: "MetaTrader 4",
      },
      {
        value: "mt5",
        text: "MetaTrader 5",
      },
    ]);

    // const route = useRoute()

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    let userInfo;

    onMounted(() => {
      status_user.value = localStorage.getItem("activeAccount");
      window.addEventListener("keydown", reset);

      emitter.on("userUpdated", () => {
        load();
      });

      load();
    });

    onUnmounted(() => {
      window.removeEventListener("keydown", reset);

      emitter.off("userUpdated");
    });

    const load = () => {
      if (!store.state.user) {
        return;
      }

      userInfo = store.state.user;

      if (userInfo !== null) {
        if (userInfo.accounts != null) {
          supportLanguage.value = userInfo.preference.emailsLanguage;
        } else {
          supportLanguage.value = "ENGLISH";
        }
      }

      sources.value = [];
      targets.value = [];
    };

    const loadTarget = () => {
      let storedAccounts = sources.value;
      if (storedAccounts != null) {
        accounts.value = storedAccounts;
        targets.value = [];
        storedAccounts.forEach((row) => {
          if (row.value != source.value) {
            addTargetAccount(row.value, row.text);
          }
        });
      }
    };

    const traslateLabel = (msg_translate) => {
      const translationMap = {
        "Internal transfer Successfull": "transfer.submited",
      };

      return translateText(msg_translate, translationMap);
    };
    /***Hacemos la transferencia***/
    const sendTransfer = () => {
      showM.value = true;

      let v = validationsSend();
      console.log(v);
      if (v === 0) {
        let _body = {
          accountFrom: source.value,
          accountTo: target.value,
          amount: amount.value,
          platform: platform.value,
        };
        disabledBtn.value = true;

        let _headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + store.state.token,
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        };

        let _url =
          process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS +
          "/transaction" +
          "/accountstransfer";
        axios({ method: "POST", url: _url, data: _body, headers: _headers })
          .then((result) => {
            if (result !== undefined) {
              if (result.data.error) {
                showM.value = false;
                disabledBtn.value = false;
                emitter.emit(
                  "showDialog",
                  i18n.global.t("transfer.showDialogOne")
                );
              } else {
                showM.value = false;
                let messa =
                  result.data.response.message == false
                    ? result.data.response.message
                    : i18n.global.t("transfer.submited");

                if (platform.value === "mt4") {
                  accountslv4()
                    .then((call_accountslv4) => {
                      if (
                        call_accountslv4 !== undefined ||
                        call_accountslv4 !== null
                      ) {
                        localStorage.setItem(
                          "Accountslv4",
                          JSON.stringify(call_accountslv4)
                        );
                        emitter.emit("accountsValuesChanged");
                      }
                    })
                    .catch((error) => {
                      logger.error(error);
                    });
                } else if (platform.value === "mt5") {
                  accountslv5()
                    .then((call_accountslv5) => {
                      if (
                        call_accountslv5 !== undefined ||
                        call_accountslv5 !== null
                      ) {
                        localStorage.setItem(
                          "Accountslv5",
                          JSON.stringify(call_accountslv5)
                        );
                        emitter.emit("accountsValuesChanged");
                      }
                    })
                    .catch((error) => {
                      logger.error(error);
                    });
                }
                // platform.value = ""
                emitter.emit("showDialog", messa);
                // source.value = ""
                // target.value = ""
                amount.value = "";
                checkbox.value = false;
                disabledBtn.value = false;
              }
            } else {
              showM.value = false;
              disabledBtn.value = false;
              emitter.emit(
                "showDialog",
                i18n.global.t("transfer.showDialogTwo")
              );
            }
          })
          .catch((error) => {
            showM.value = false;
            console.log(error);
            emitter.emit("showDialog", error.response.data.message);
            logger.error(error);
          });
      } else {
        showM.value = false;
      }
    };

    /**SELECT cuentas para enviar dinero****/
    const addSourceAccount = (accountValue, accountLabel) => {
      sources.value.push({
        value: accountValue,
        text: accountLabel,
      });
    };

    /**SELECT cuentas para recibir dinero****/
    const addTargetAccount = (accountValue, accountLabel) => {
      targets.value.push({
        value: accountValue,
        text: accountLabel,
      });
    };

    /**Validaciones antes de hacer la transferencia****/
    const validationsSend = () => {
      let valid = "";
      let flag = 0;

      let required = [
        platform.value,
        source.value,
        target.value,
        amount.value,
        checkbox.value,
      ];

      for (let i = 0; i < required.length; i++) {
        console.log(required[i]);
        if (
          required[i] === undefined ||
          required[i] === null ||
          required[i] === "" ||
          required[i] === false
        ) {
          // valid = false
          emitter.emit("showDialog", i18n.global.t("transfer.error"));
          showM.value = false;
          flag = 1;
          return false;
        } else {
          valid = true;
        }
      }

      /// validación campos no vacios
      if (!valid) {
        emitter.emit("showDialog", i18n.global.t("transfer.error"));
        showM.value = false;
        flag = 1;
        return false;
      } else {
        flag = 0;
      }

      // Validación numero de cuenta distinto
      if (source.value === target.value) {
        emitter.emit("showDialog", i18n.global.t("transfer.errorTwo"));
        showM.value = false;
        flag = 2;
        return false;
      } else {
        flag = 0;
      }

      if (amount.value <= 0) {
        emitter.emit("showDialog", i18n.global.t("transfer.errorThree"));
        showM.value = false;
        flag = 1;
        return false;
      }

      // Validación saldo suficiente en la cuenta
      let selectedAccount = [];
      let account = source.value;
      selectedAccount = accountsNumber.value.filter((d) => d.login === account);
      if (amount.value > parseInt(selectedAccount[0].balance)) {
        emitter.emit("showDialog", i18n.global.t("transfer.errorFour"));
        showM.value = false;
        flag = 3;
        return false;
      } else {
        flag = 0;
      }

      return flag;
    };

    const allow = computed(() => {
      let sourceDefined = source.value !== null;
      let targetDefined = target.value !== null;
      let sourceTargetCorrect = source.value !== target.value;
      let amountDefined = amount.value !== null && amount.value > 0;

      return (
        sourceDefined &&
        targetDefined &&
        sourceTargetCorrect &&
        amountDefined &&
        checkbox.value
      );
    });

    const reset = (e) => {
      if (e.key === "Escape") {
        source.value = null;
        target.value = null;
        amount.value = null;
      }
    };

    watch(platform, () => {
      sources.value = [];
      targets.value = [];
      let platforChange = "";
      if (platform.value == "mt4") {
        platforChange = "mt4checkaccounts";
        accounts = JSON.parse(localStorage.getItem("Accountslv4"));
      }
      if (platform.value == "mt5") {
        platforChange = "mt5checkaccounts";
        accounts = JSON.parse(localStorage.getItem("Accountslv5"));
      }

      if (
        status_user.value == "AT_DETAILS" ||
        status_user.value == "PENDING_VALIDATION" ||
        status_user.value == "NOT_APROVED"
      ) {
        emitter.emit(
          "dynamicMessage",
          i18n.global.t("accounts.dialogShowFive")
        );
      } else {
        showM.value = true;
        disabledBtn.value = true;
        showM.value = false;
        if (accounts != null) {
          accountsNumber.value = accounts;
          accounts.forEach((row) => {
            sources.value.push({
              value: row.login,
              text: row.login,
            });
          });
          disabledBtn.value = false;
        }
      }
    });

    return {
      sendTransfer,
      reset,
      accounts,
      disabledBtn,
      addSourceAccount,

      busy,
      allow,

      checkbox,

      supportLanguage,
      showM,
      platforms,
      platform,

      source,
      sources,
      target,
      targets,
      amount,
      loadTarget,
      accountsLive,

      validationsSend,
    };
  },
};
</script>

<style scoped></style>
